import React from 'react';
import PropTypes from 'prop-types';

import {
    ChartHeader,
    RowItem,
    RowHeaderBase,
} from 'lib/components/_charts/ChartRowAndHeader.styles';
import { TurbineStatusLegend } from './TurbineStatusLegend';

export const TurbineStatusChartRowHeader = ({ width, chartWidth }) => (
    <ChartHeader chartWidth={chartWidth}>
        <RowHeaderBase width={width}>
            <RowItem>&nbsp;</RowItem>
        </RowHeaderBase>

        <TurbineStatusLegend />
    </ChartHeader>
);

TurbineStatusChartRowHeader.displayName = 'TurbineStatusChartRowHeader';

TurbineStatusChartRowHeader.propTypes = {
    width: PropTypes.number,
};

TurbineStatusChartRowHeader.defaultProps = {
    width: 400,
};
